// utils/authLoader.ts
import { redirect } from "react-router-dom";
import { getToken } from './util'; // 封装的获取token方法
import { store } from '@/store/index'
import { clearTokens } from '@/store/user/userInfo'
//路由跳转之前增加校验
export function authLoader() {
  const token = getToken('token');
  if (!token) {
    throw redirect("/login");
  }
  const expireStr = localStorage.getItem('tokenExpire');
  if (!expireStr) {
    store.dispatch(clearTokens())
    throw redirect("/login");
  }
  const tokenExpire = Number(expireStr);
  if (Date.now() > tokenExpire) {
    localStorage.removeItem('tokenExpire');
    store.dispatch(clearTokens())
    throw redirect("/login");
  }
  return null; // 验证通过则继续渲染页面
}
